module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (134).b2593565.jpg";